"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_BL_ORDER_VARIABLE_PATHS = exports.BL_ORDER_VARIABLE_NAMESPACE = exports.BL_ORDER_VARIABLE_GROUP_LABELS = exports.blOrderVariableGroupSchema = exports.BL_ORDER_VARIABLE_GROUPS = void 0;
const zod_1 = require("zod");
exports.BL_ORDER_VARIABLE_GROUPS = [
    'metycle',
    'bl_extraction',
    'consignee',
    'notify_party',
    'ports',
    'order_details',
    'order_reference',
    'financial',
    'computed',
    'operator_input',
    'containers',
];
exports.blOrderVariableGroupSchema = zod_1.z.enum(exports.BL_ORDER_VARIABLE_GROUPS);
exports.BL_ORDER_VARIABLE_GROUP_LABELS = {
    metycle: 'Metycle Company Info',
    bl_extraction: 'BL Extraction Fields',
    consignee: 'Consignee',
    notify_party: 'Notify Party',
    ports: 'Ports',
    order_details: 'Order Details',
    order_reference: 'Order Reference',
    financial: 'Financial',
    computed: 'Computed Lines',
    operator_input: 'Operator Input',
    containers: 'Containers (repeating)',
};
exports.BL_ORDER_VARIABLE_NAMESPACE = {
    metycle: {
        repeating: false,
        variables: [
            { path: 'metycle_name', label: 'Company Name' },
            { path: 'metycle_address', label: 'Address' },
            { path: 'metycle_city', label: 'City' },
            { path: 'metycle_country', label: 'Country' },
            { path: 'metycle_phone', label: 'Phone' },
            { path: 'metycle_email', label: 'Email' },
            { path: 'metycle_managing_directors', label: 'Managing Directors' },
            { path: 'metycle_register', label: 'Company Register' },
            { path: 'metycle_vat_id', label: 'VAT ID' },
            { path: 'metycle_bank_1', label: 'Bank 1 Name' },
            { path: 'metycle_iban_1', label: 'Bank 1 IBAN' },
            { path: 'metycle_bic_1', label: 'Bank 1 BIC' },
            { path: 'metycle_bank_2', label: 'Bank 2 Name' },
            { path: 'metycle_iban_2', label: 'Bank 2 IBAN' },
            { path: 'metycle_bic_2', label: 'Bank 2 BIC' },
            { path: 'metycle_logo_base64', label: 'Logo (base64)' },
            { path: 'current_date', label: 'Current Date' },
        ],
    },
    bl_extraction: {
        repeating: false,
        variables: [
            { path: 'bl_number', label: 'BL Number' },
            { path: 'bl_issue_date', label: 'BL Issue Date' },
            { path: 'vessel_name', label: 'Vessel Name' },
            { path: 'shipper', label: 'Shipper' },
            { path: 'country_of_origin', label: 'Country of Origin' },
            { path: 'product_description', label: 'Product Description' },
            { path: 'hs_code', label: 'HS Code' },
            { path: 'number_of_packages', label: 'Number of Packages' },
            { path: 'applicable_free_days', label: 'Applicable Free Days' },
            { path: 'description_of_goods', label: 'Description of Goods' },
            { path: 'total_net_weight', label: 'Total Net Weight (kg)' },
            { path: 'total_gross_weight', label: 'Total Gross Weight (kg)' },
            { path: 'number_of_containers', label: 'Number of Containers' },
            { path: 'onboard_date', label: 'Onboard Date' },
        ],
    },
    consignee: {
        repeating: false,
        variables: [
            { path: 'consignee_name', label: 'Consignee Name' },
            { path: 'consignee_address', label: 'Consignee Address' },
            { path: 'consignee_contact_person_name', label: 'Consignee Contact Person Name' },
            { path: 'consignee_contact_person_email', label: 'Consignee Contact Person Email' },
        ],
    },
    notify_party: {
        repeating: false,
        variables: [
            { path: 'notify_name', label: 'Notify Party Name' },
            { path: 'notify_address', label: 'Notify Party Address' },
            { path: 'notify_contact_person_name', label: 'Notify Party Contact Person Name' },
            { path: 'notify_contact_person_email', label: 'Notify Party Contact Person Email' },
        ],
    },
    ports: {
        repeating: false,
        variables: [
            { path: 'port_of_loading', label: 'Port of Loading' },
            { path: 'port_of_discharge', label: 'Port of Discharge' },
            { path: 'final_destination', label: 'Final Destination' },
        ],
    },
    order_details: {
        repeating: false,
        variables: [
            { path: 'bl_order_name', label: 'BL Order Name' },
            { path: 'etd', label: 'ETD (Estimated Time of Departure)' },
            { path: 'eta', label: 'ETA (Estimated Time of Arrival)' },
            { path: 'atd', label: 'ATD (Actual Time of Departure)' },
            { path: 'ata', label: 'ATA (Actual Time of Arrival)' },
            { path: 'initial_eta', label: 'Initial ETA' },
            { path: 'eta_final_destination', label: 'ETA at Final Destination' },
            { path: 'ata_final_destination', label: 'ATA at Final Destination' },
            { path: 'ata_customer', label: 'ATA at Customer' },
            { path: 'booking_date', label: 'Booking Date' },
            { path: 'loading_date', label: 'Loading Date' },
            { path: 'customs_clearance', label: 'Customs Clearance Date' },
            { path: 'bl_release_date', label: 'BL Release Date' },
            { path: 'bl_confirmed_date', label: 'BL Confirmed Date' },
            { path: 'documents_sent_date', label: 'Documents Sent Date' },
            { path: 'sold_date', label: 'Sold Date' },
            { path: 'sorting_at_buyers_factory', label: "Sorting at Buyer's Factory" },
            { path: 'container_type', label: 'Container Type' },
            { path: 'container_size', label: 'Container Size' },
            { path: 'freight_forwarder', label: 'Freight Forwarder' },
            { path: 'shipping_line', label: 'Shipping Line' },
            { path: 'total_quantity_mt', label: 'Total Quantity (MT)' },
            { path: 'loaded_quantity_mt', label: 'Loaded Quantity (MT)' },
            { path: 'financing_partner', label: 'Financing Partner' },
        ],
    },
    order_reference: {
        repeating: false,
        variables: [
            { path: 'order_id', label: 'Order ID' },
            { path: 'order_reference', label: 'Order Reference' },
            { path: 'commodity_type', label: 'Commodity Type' },
            { path: 'isri_grade', label: 'ISRI Grade' },
            { path: 'product_details', label: 'Product Details' },
        ],
    },
    financial: {
        repeating: false,
        variables: [
            { path: 'revenue', label: 'Revenue' },
            { path: 'cost', label: 'Cost' },
            { path: 'sell_final_price', label: 'Sell Final Price' },
            { path: 'buy_final_price', label: 'Buy Final Price' },
            { path: 'sell_mutually_agreed_price', label: 'Sell Mutually Agreed Price' },
            {
                path: 'sell_mutually_agreed_price_currency',
                label: 'Sell Mutually Agreed Price Currency',
            },
            { path: 'buy_mutually_agreed_price', label: 'Buy Mutually Agreed Price' },
            { path: 'buy_mutually_agreed_price_currency', label: 'Buy Mutually Agreed Price Currency' },
            { path: 'sell_weighted_lme', label: 'Sell Weighted LME' },
            { path: 'buy_weighted_lme', label: 'Buy Weighted LME' },
            { path: 'sell_fixed_quantity', label: 'Sell Fixed Quantity' },
            { path: 'buy_fixed_quantity', label: 'Buy Fixed Quantity' },
            { path: 'sell_fixed_date', label: 'Sell Fixed Date' },
            { path: 'buy_fixed_date', label: 'Buy Fixed Date' },
            { path: 'downpayment_original_due_date', label: 'Downpayment Due Date (original)' },
            { path: 'downpayment_actual_due_date', label: 'Downpayment Due Date (actual)' },
            { path: 'latest_repayment_date', label: 'Latest Repayment Date' },
        ],
    },
    computed: {
        repeating: false,
        variables: [
            { path: 'country_of_origin_line', label: 'Country of Origin (display line)' },
            { path: 'containers_and_seals', label: 'Containers + Seals (one-line summary)' },
            { path: 'container_numbers', label: 'Container Numbers (comma-separated)' },
            { path: 'containers_table', label: 'Containers Table (rendered HTML)' },
            { path: 'shipment_weight_lines', label: 'Shipment Weight Lines (display)' },
            { path: 'consignee_vat_line', label: 'Consignee VAT (HTML line)' },
            { path: 'consignee_pan_line', label: 'Consignee PAN (HTML line)' },
            { path: 'consignee_iec_line', label: 'Consignee IEC (HTML line)' },
            { path: 'notify_vat_line', label: 'Notify VAT (HTML line)' },
            { path: 'notify_pan_line', label: 'Notify PAN (HTML line)' },
            { path: 'notify_iec_line', label: 'Notify IEC (HTML line)' },
        ],
    },
    operator_input: {
        repeating: false,
        variables: [
            { path: 'manual_CoO_input', label: 'Manual Country-of-Origin Input' },
            { path: 'document_notes_section', label: 'Document Notes Section' },
            { path: 'additional_remarks', label: 'Additional Remarks' },
            { path: 'invoice_number', label: 'Invoice Number' },
        ],
    },
    containers: {
        repeating: true,
        section: 'containers',
        variables: [
            { path: 'container_number', label: 'Container Number' },
            { path: 'seal_number', label: 'Seal Number' },
            { path: 'net_weight', label: 'Net Weight (kg)' },
            { path: 'gross_weight', label: 'Gross Weight (kg)' },
            { path: 'container_size', label: 'Container Size' },
            { path: 'bl_number', label: 'BL Number (per container)' },
        ],
    },
};
exports.ALL_BL_ORDER_VARIABLE_PATHS = Object.values(exports.BL_ORDER_VARIABLE_NAMESPACE).flatMap((group) => group.variables.map((v) => v.path));
//# sourceMappingURL=bl-order-variable-namespace.js.map